// import { Box, Button, Card, CardActions, CardContent, CardHeader, CardMedia, Grid, Typography } from '@mui/material';
// import React from 'react';
// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
// import { LAUNCH_COURSE } from '../../helper/url_helper';

// const MyScormCourseCard = ({ course }) => {
//     const handleLaunchCourse = (course) => {
//         const studentId = JSON.parse(localStorage.getItem('student')).id;
//         const type = "student";
//         console.log(`${LAUNCH_COURSE}/${course.storagePath}?courseId=${course.id}&studentId=${studentId}&type=${type}`)
//         window.open(`${LAUNCH_COURSE}/${course.storagePath}?courseId=${course.id}&studentId=${studentId}&type=${type}`, '_blank');
//     };
//     return (
//         <>
//             <Grid item key={course.id} xs={12} sm={6} md={4}>
//                 <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//                     {course.thumbnailUrl ? (
//                         <CardMedia
//                             component="img"
//                             height="180"
//                             image={course.thumbnailUrl}
//                             alt={`${course.title} thumbnail`}
//                         />
//                     ) : (
//                         <Box
//                             height="180px"
//                             display="flex"
//                             alignItems="center"
//                             justifyContent="center"
//                             sx={{
//                                 backgroundColor: '#f5f5f5',
//                                 color: '#888',
//                                 fontStyle: 'italic'
//                             }}
//                         >
//                             No Thumbnail
//                         </Box>
//                     )}
//                     <CardHeader
//                         title={course.title}
//                         subheader={`Version: ${course.version || 'N/A'}`}
//                     />
//                     <CardContent sx={{ flexGrow: 1 }}>
//                         <Typography variant="body2" color="text.secondary">
//                             Click 'Launch' to start the course.
//                         </Typography>
//                     </CardContent>
//                     <CardActions>
//                         <Button
//                             variant="contained"
//                             size="small"
//                             startIcon={<RocketLaunchIcon />}
//                             onClick={() => handleLaunchCourse(course)}
//                         >
//                             Launch
//                         </Button>
//                     </CardActions>
//                 </Card>
//             </Grid>
//         </>
//     )
// }

// export default MyScormCourseCard;










// MyScormCourseCard.jsx - Mobile Optimized with Pagination
import { 
    Box, Button, Card, CardActions, CardContent, CardHeader, CardMedia, 
    Grid, Typography, Chip, CircularProgress, Stack, Paper, 
    IconButton, useTheme, useMediaQuery, Pagination, 
    PaginationItem, Fade, Zoom, Badge, Skeleton,
    LinearProgress, Divider, Tooltip
} from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import SchoolIcon from '@mui/icons-material/School';
import StarIcon from '@mui/icons-material/Star';
import { LAUNCH_COURSE } from '../../helper/url_helper';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://backend.skillserve.in';

const MyScormCourseCard = ({ course, onCourseComplete }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    
    const [isCompleted, setIsCompleted] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true);
    const [score, setScore] = useState(null);
    const [lessonStatus, setLessonStatus] = useState(null);
    const [isLaunching, setIsLaunching] = useState(false);

    // Check completion status from backend
    const checkCompletionStatus = useCallback(async () => {
        try {
            const student = JSON.parse(localStorage.getItem('student'));
            if (!student || !student.id) {
                setCheckingStatus(false);
                return;
            }

            const studentId = student.id;
            const courseId = course.id;

            console.log(`Checking completion for course ${courseId}, student ${studentId}`);
            
            const response = await axios.get(`${API_BASE_URL}/api/scorm/check-completion/${courseId}/${studentId}`);
            
            console.log("Completion check response:", response.data);
            
            if (response.data?.success && response.data?.result?.length > 0) {
                const result = response.data.result[0];
                setIsCompleted(result.completed === true);
                if (result.score) {
                    setScore(result.score);
                }
                if (result.lessonStatus) {
                    setLessonStatus(result.lessonStatus);
                }
            } else {
                setIsCompleted(false);
            }
        } catch (error) {
            console.error("Error checking completion:", error);
            setIsCompleted(false);
        } finally {
            setCheckingStatus(false);
        }
    }, [course.id]);

    useEffect(() => {
        checkCompletionStatus();
        
        const pendingCompletion = localStorage.getItem('scorm_pending_completion');
        if (pendingCompletion === 'true') {
            localStorage.removeItem('scorm_pending_completion');
            setTimeout(() => {
                checkCompletionStatus();
                if (onCourseComplete) {
                    onCourseComplete(course.id);
                }
            }, 1500);
        }
        
        const manualCompletionKey = `course_completed_${course.id}`;
        const manuallyCompleted = localStorage.getItem(manualCompletionKey);
        if (manuallyCompleted === 'true') {
            localStorage.removeItem(manualCompletionKey);
            setTimeout(() => {
                checkCompletionStatus();
                if (onCourseComplete) {
                    onCourseComplete(course.id);
                }
            }, 1000);
        }
    }, [checkCompletionStatus, course.id, onCourseComplete]);

    const handleLaunchCourse = async () => {
        setIsLaunching(true);
        try {
            const student = JSON.parse(localStorage.getItem('student'));
            const studentId = student.id;
            const type = "student";
            
            const url = `${LAUNCH_COURSE}/${course.storagePath}?courseId=${course.id}&studentId=${studentId}&type=${type}`;
            
            console.log("Launching course URL:", url);
            
            localStorage.setItem('scorm_return_url', window.location.pathname);
            localStorage.setItem('scorm_current_course_id', course.id);
            localStorage.setItem('scorm_current_student_id', studentId);
            
            // For mobile, open in new tab
            if (isMobile) {
                window.open(url, '_blank');
            } else {
                window.open(url, '_blank', 'width=1200,height=800,toolbar=yes,scrollbars=yes,resizable=yes');
            }
            
            // Reset launching state after 3 seconds
            setTimeout(() => setIsLaunching(false), 3000);
        } catch (error) {
            console.error("Error launching course:", error);
            alert('Failed to launch course: ' + error.message);
            setIsLaunching(false);
        }
    };

    if (checkingStatus) {
        return (
            <Card sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%', 
                alignItems: 'center', 
                justifyContent: 'center', 
                py: 4,
                minHeight: isMobile ? 200 : 250
            }}>
                <CircularProgress size={isMobile ? 30 : 40} />
                <Typography variant="caption" sx={{ mt: 2 }}>Loading status...</Typography>
            </Card>
        );
    }

    // Determine card size based on viewport
    const isSmallCard = isMobile || isTablet;

    return (
        <Card sx={{ 
            display: 'flex', 
            flexDirection: isMobile ? 'column' : 'column',
            height: '100%',
            position: 'relative',
            transition: 'all 0.3s ease',
            '&:hover': { 
                transform: isMobile ? 'scale(1.01)' : 'translateY(-5px)', 
                boxShadow: isMobile ? 4 : 8 
            },
            opacity: isCompleted ? 0.95 : 1,
            borderRadius: isMobile ? 2 : 3,
            overflow: 'hidden'
        }}>
            {/* Completion Badge - Stamp Style */}
            {isCompleted && (
                <Zoom in={true} style={{ transitionDelay: '200ms' }}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: isMobile ? 12 : 16,
                            right: isMobile ? 12 : 16,
                            zIndex: 10,
                            transform: isMobile ? 'rotate(10deg)' : 'rotate(15deg)',
                        }}
                    >
                        <Chip
                            icon={<CheckCircleIcon />}
                            label={isMobile ? "✓ COMPLETED" : (score ? `COMPLETED - ${score}%` : "COMPLETED")}
                            color="success"
                            size={isMobile ? "small" : "medium"}
                            sx={{
                                fontWeight: 'bold',
                                fontSize: isMobile ? '0.6rem' : '0.75rem',
                                height: isMobile ? 28 : 32,
                                boxShadow: 3,
                                '& .MuiChip-icon': { 
                                    fontSize: isMobile ? 14 : 18, 
                                    color: 'white' 
                                },
                                '& .MuiChip-label': { 
                                    fontWeight: 'bold', 
                                    letterSpacing: '0.5px',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem'
                                }
                            }}
                        />
                    </Box>
                </Zoom>
            )}

            {/* Card Media / Thumbnail */}
            {course.thumbnailUrl ? (
                <CardMedia
                    component="img"
                    height={isMobile ? 140 : 180}
                    image={course.thumbnailUrl}
                    alt={course.title}
                    sx={{ 
                        filter: isCompleted ? 'brightness(0.95) contrast(0.95)' : 'none',
                        objectFit: 'cover'
                    }}
                />
            ) : (
                <Box
                    height={isMobile ? 140 : 180}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ 
                        backgroundColor: isCompleted ? '#4caf50' : '#f5f5f5',
                        background: isCompleted ? 'linear-gradient(135deg, #4caf50, #45a049)' : '#f5f5f5',
                        color: isCompleted ? 'white' : '#888',
                        position: 'relative',
                        transition: 'all 0.3s ease'
                    }}
                >
                    {isCompleted ? (
                        <Box textAlign="center" sx={{ p: 2 }}>
                            <CheckCircleIcon sx={{ fontSize: isMobile ? 36 : 48, mb: 1 }} />
                            <Typography variant={isMobile ? "caption" : "body2"}>
                                Course Completed
                            </Typography>
                            {score && (
                                <Typography variant="caption" sx={{ display: 'block' }}>
                                    Score: {score}%
                                </Typography>
                            )}
                        </Box>
                    ) : (
                        <Box textAlign="center">
                            <SchoolIcon sx={{ fontSize: isMobile ? 36 : 48, color: '#bbb' }} />
                            <Typography variant="caption" sx={{ display: 'block', color: '#999' }}>
                                {isMobile ? 'Course' : 'No Thumbnail'}
                            </Typography>
                        </Box>
                    )}
                </Box>
            )}
            
            {/* Card Header */}
            <CardHeader
                title={
                    <Typography 
                        variant={isMobile ? "subtitle1" : "h6"} 
                        sx={{ 
                            fontWeight: 600, 
                            fontSize: isMobile ? '0.95rem' : '1.1rem',
                            lineHeight: 1.3,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}
                    >
                        {course.title}
                    </Typography>
                }
                subheader={
                    <Stack 
                        direction="row" 
                        spacing={0.5} 
                        alignItems="center" 
                        sx={{ 
                            mt: 0.5, 
                            flexWrap: 'wrap',
                            gap: 0.5
                        }}
                    >
                        <Typography variant="caption" color="text.secondary">
                            Version: {course.version || '1.2'}
                        </Typography>
                        
                        {lessonStatus && !isCompleted && (
                            <Chip 
                                label={lessonStatus} 
                                size="small" 
                                color="info"
                                variant="outlined"
                                sx={{ 
                                    height: isMobile ? 18 : 20, 
                                    fontSize: isMobile ? '0.55rem' : '0.7rem'
                                }}
                            />
                        )}
                        
                        {score !== null && isCompleted && (
                            <Chip 
                                label={`Score: ${score}%`} 
                                size="small" 
                                color={parseInt(score) >= 80 ? "success" : "warning"}
                                variant="outlined"
                                sx={{ 
                                    height: isMobile ? 18 : 20, 
                                    fontSize: isMobile ? '0.55rem' : '0.7rem'
                                }}
                            />
                        )}
                    </Stack>
                }
                sx={{ 
                    pb: 0,
                    '& .MuiCardHeader-content': { 
                        overflow: 'hidden',
                        width: '100%'
                    }
                }}
            />
            
            {/* Card Content */}
            <CardContent sx={{ 
                flexGrow: 1, 
                pt: 1,
                pb: isMobile ? 1 : 2
            }}>
                {isCompleted ? (
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1,
                        bgcolor: 'success.light',
                        color: 'success.contrastText',
                        p: isMobile ? 1 : 1.5,
                        borderRadius: 2
                    }}>
                        <CheckCircleIcon sx={{ fontSize: isMobile ? 16 : 20 }} />
                        <Typography 
                            variant={isMobile ? "caption" : "body2"} 
                            color="success.contrastText"
                            sx={{ fontWeight: 500 }}
                        >
                            {score ? `Completed! Score: ${score}%` : 'Successfully Completed!'}
                        </Typography>
                    </Box>
                ) : lessonStatus ? (
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1,
                        bgcolor: 'info.light',
                        color: 'info.contrastText',
                        p: isMobile ? 1 : 1.5,
                        borderRadius: 2
                    }}>
                        <SchoolIcon sx={{ fontSize: isMobile ? 16 : 20 }} />
                        <Typography 
                            variant={isMobile ? "caption" : "body2"} 
                            color="info.contrastText"
                            sx={{ fontWeight: 500 }}
                        >
                            Progress: {lessonStatus}
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1,
                        bgcolor: 'action.hover',
                        p: isMobile ? 1 : 1.5,
                        borderRadius: 2
                    }}>
                        <RocketLaunchIcon sx={{ fontSize: isMobile ? 16 : 20, color: 'primary.main' }} />
                        <Typography 
                            variant={isMobile ? "caption" : "body2"} 
                            color="text.secondary"
                        >
                            {isMobile ? 'Ready to start' : 'Ready to launch this SCORM course'}
                        </Typography>
                    </Box>
                )}
            </CardContent>
            
            {/* Card Actions */}
            <CardActions sx={{ 
                p: isMobile ? 1.5 : 2, 
                pt: 0,
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? 1 : 0
            }}>
                <Button
                    fullWidth
                    variant={isCompleted ? "outlined" : "contained"}
                    size={isMobile ? "medium" : "medium"}
                    startIcon={isLaunching ? <CircularProgress size={20} /> : <RocketLaunchIcon />}
                    onClick={handleLaunchCourse}
                    disabled={isLaunching}
                    sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        py: isMobile ? 1.5 : 1,
                        fontSize: isMobile ? '0.9rem' : '1rem',
                        ...(isCompleted && {
                            borderColor: '#4caf50',
                            color: '#4caf50',
                            '&:hover': { borderColor: '#388e3c', color: '#388e3c' }
                        })
                    }}
                >
                    {isLaunching ? 'Launching...' : (isCompleted ? 'Review Course' : 'Launch Course')}
                </Button>
            </CardActions>
        </Card>
    );
};

// Paginated Course Grid Component
export const PaginatedCourseGrid = ({ 
    courses, 
    onCourseComplete, 
    coursesPerPage = 6,
    showPagination = true 
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    
    const [page, setPage] = useState(1);
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
    const [completedCount, setCompletedCount] = useState(0);

    // Calculate responsive items per page
    const getItemsPerPage = () => {
        if (isMobile) return 4;
        if (isTablet) return 6;
        return coursesPerPage;
    };

    const itemsPerPage = getItemsPerPage();
    const totalPages = Math.ceil(courses.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const currentCourses = courses.slice(startIndex, startIndex + itemsPerPage);

    // Handle page change
    const handlePageChange = (event, value) => {
        setPage(value);
        // Scroll to top when changing page on mobile
        if (isMobile) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Track completed courses
    useEffect(() => {
        const completed = courses.filter(c => {
            const key = `course_completed_${c.id}`;
            return localStorage.getItem(key) === 'true';
        }).length;
        setCompletedCount(completed);
    }, [courses]);

    // Handle course completion
    const handleCourseComplete = (courseId) => {
        setCompletedCount(prev => prev + 1);
        if (onCourseComplete) {
            onCourseComplete(courseId);
        }
    };

    // Render grid view
    const renderGridView = () => (
        <Grid container spacing={isMobile ? 1.5 : 3}>
            {currentCourses.map((course) => (
                <Grid item xs={12} sm={6} md={4} key={course.id}>
                    <MyScormCourseCard 
                        course={course} 
                        onCourseComplete={handleCourseComplete}
                    />
                </Grid>
            ))}
        </Grid>
    );

    // Render list view (mobile optimized)
    const renderListView = () => (
        <Stack spacing={isMobile ? 1.5 : 2}>
            {currentCourses.map((course) => (
                <Paper 
                    key={course.id}
                    elevation={1}
                    sx={{ 
                        p: isMobile ? 1.5 : 2,
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'stretch' : 'center',
                        gap: isMobile ? 1.5 : 2,
                        transition: 'all 0.2s ease',
                        '&:hover': { 
                            boxShadow: 3,
                            transform: 'scale(1.01)'
                        }
                    }}
                >
                    {/* Thumbnail */}
                    <Box
                        sx={{
                            width: isMobile ? '100%' : 120,
                            height: isMobile ? 120 : 80,
                            borderRadius: 1,
                            overflow: 'hidden',
                            flexShrink: 0,
                            bgcolor: '#f5f5f5',
                            position: 'relative'
                        }}
                    >
                        {course.thumbnailUrl ? (
                            <img 
                                src={course.thumbnailUrl} 
                                alt={course.title}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                        ) : (
                            <Box 
                                display="flex" 
                                alignItems="center" 
                                justifyContent="center"
                                sx={{ width: '100%', height: '100%', bgcolor: '#e0e0e0' }}
                            >
                                <SchoolIcon sx={{ color: '#999' }} />
                            </Box>
                        )}
                        
                        {/* Completion badge for list view */}
                        {localStorage.getItem(`course_completed_${course.id}`) === 'true' && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 4,
                                    right: 4,
                                    bgcolor: 'success.main',
                                    borderRadius: '50%',
                                    width: 24,
                                    height: 24,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <CheckCircleIcon sx={{ fontSize: 16, color: 'white' }} />
                            </Box>
                        )}
                    </Box>

                    {/* Course Info */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography 
                            variant={isMobile ? "subtitle1" : "h6"} 
                            sx={{ 
                                fontWeight: 600,
                                fontSize: isMobile ? '0.95rem' : '1.1rem',
                                display: '-webkit-box',
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                            }}
                        >
                            {course.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Version: {course.version || '1.2'}
                        </Typography>
                        
                        {/* Progress indicator */}
                        {localStorage.getItem(`course_completed_${course.id}`) === 'true' ? (
                            <Chip 
                                label="Completed" 
                                color="success" 
                                size="small"
                                sx={{ mt: 0.5, height: 20 }}
                            />
                        ) : (
                            <Chip 
                                label="In Progress" 
                                color="warning" 
                                size="small"
                                sx={{ mt: 0.5, height: 20 }}
                            />
                        )}
                    </Box>

                    {/* Action Button */}
                    <Button
                        variant="contained"
                        size={isMobile ? "small" : "medium"}
                        startIcon={<RocketLaunchIcon />}
                        onClick={() => {
                            // Find and launch the course
                            const courseRef = course;
                            const student = JSON.parse(localStorage.getItem('student'));
                            if (student) {
                                const url = `${LAUNCH_COURSE}/${courseRef.storagePath}?courseId=${courseRef.id}&studentId=${student.id}&type=student`;
                                window.open(url, '_blank');
                            }
                        }}
                        sx={{ 
                            whiteSpace: 'nowrap',
                            minWidth: isMobile ? '100%' : 120
                        }}
                    >
                        {isMobile ? 'Launch' : 'Launch Course'}
                    </Button>
                </Paper>
            ))}
        </Stack>
    );

    // Header with view controls
    const renderHeader = () => (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            mb: isMobile ? 2 : 3,
            flexWrap: 'wrap',
            gap: 1
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: 600 }}>
                    My Courses
                </Typography>
                <Badge 
                    badgeContent={completedCount} 
                    color="success"
                    sx={{ '& .MuiBadge-badge': { fontSize: isMobile ? '0.7rem' : '0.8rem' } }}
                >
                    <Typography variant="caption" color="text.secondary">
                        {courses.length} total
                    </Typography>
                </Badge>
            </Box>
            
            {!isMobile && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        size="small"
                        variant={viewMode === 'grid' ? 'contained' : 'outlined'}
                        startIcon={<ViewModuleIcon />}
                        onClick={() => setViewMode('grid')}
                    >
                        Grid
                    </Button>
                    <Button
                        size="small"
                        variant={viewMode === 'list' ? 'contained' : 'outlined'}
                        startIcon={<ViewCarouselIcon />}
                        onClick={() => setViewMode('list')}
                    >
                        List
                    </Button>
                </Box>
            )}
        </Box>
    );

    // Progress bar for overall completion
    const renderProgress = () => {
        const percentage = courses.length > 0 ? (completedCount / courses.length) * 100 : 0;
        return (
            <Box sx={{ mb: isMobile ? 2 : 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="caption" color="text.secondary">
                        Overall Progress
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {Math.round(percentage)}%
                    </Typography>
                </Box>
                <LinearProgress 
                    variant="determinate" 
                    value={percentage} 
                    sx={{ 
                        height: isMobile ? 6 : 8, 
                        borderRadius: 4,
                        bgcolor: 'action.hover'
                    }}
                    color={percentage === 100 ? 'success' : 'primary'}
                />
            </Box>
        );
    };

    return (
        <Box sx={{ p: isMobile ? 1 : 2 }}>
            {renderHeader()}
            {renderProgress()}
            
            {viewMode === 'grid' ? renderGridView() : renderListView()}
            
            {/* Pagination */}
            {showPagination && totalPages > 1 && (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    mt: isMobile ? 3 : 4,
                    mb: isMobile ? 2 : 0
                }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        size={isMobile ? "medium" : "large"}
                        variant="outlined"
                        shape="rounded"
                        renderItem={(item) => (
                            <PaginationItem
                                {...item}
                                components={{
                                    previous: () => (
                                        <Tooltip title="Previous">
                                            <Button 
                                                variant="outlined" 
                                                size="small"
                                                sx={{ minWidth: isMobile ? 36 : 40 }}
                                            >
                                                <ArrowBackIosNewIcon sx={{ fontSize: isMobile ? 16 : 20 }} />
                                            </Button>
                                        </Tooltip>
                                    ),
                                    next: () => (
                                        <Tooltip title="Next">
                                            <Button 
                                                variant="outlined" 
                                                size="small"
                                                sx={{ minWidth: isMobile ? 36 : 40 }}
                                            >
                                                <ArrowForwardIosIcon sx={{ fontSize: isMobile ? 16 : 20 }} />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        )}
                        sx={{
                            '& .MuiPaginationItem-root': {
                                fontSize: isMobile ? '0.85rem' : '1rem',
                                minWidth: isMobile ? 36 : 40,
                                height: isMobile ? 36 : 40,
                                borderRadius: 2
                            },
                            '& .Mui-selected': {
                                bgcolor: 'primary.main',
                                color: 'white',
                                '&:hover': { bgcolor: 'primary.dark' }
                            }
                        }}
                    />
                </Box>
            )}
            
            {/* Mobile quick stats */}
            {isMobile && (
                <Paper 
                    elevation={0} 
                    sx={{ 
                        mt: 2, 
                        p: 1.5, 
                        bgcolor: 'action.hover',
                        borderRadius: 2,
                        display: 'flex',
                        justifyContent: 'space-around'
                    }}
                >
                    <Box textAlign="center">
                        <Typography variant="caption" color="text.secondary">Total</Typography>
                        <Typography variant="subtitle1" fontWeight={600}>{courses.length}</Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box textAlign="center">
                        <Typography variant="caption" color="text.secondary">Completed</Typography>
                        <Typography variant="subtitle1" fontWeight={600} color="success.main">
                            {completedCount}
                        </Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box textAlign="center">
                        <Typography variant="caption" color="text.secondary">In Progress</Typography>
                        <Typography variant="subtitle1" fontWeight={600} color="warning.main">
                            {courses.length - completedCount}
                        </Typography>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default MyScormCourseCard;
